var map = {
	"./glyph-0.png": 796121,
	"./glyph-1.png": 80368,
	"./glyph-2.png": 45771,
	"./glyph-3.png": 282114,
	"./glyph-4.png": 974909,
	"./glyph-5.png": 753780,
	"./glyph-6.png": 676239,
	"./glyph-7.png": 907494,
	"./glyph-8.png": 147297,
	"./glyph-9.png": 874584,
	"./glyph-comma.png": 705752,
	"./icon-silver-coin.png": 347581,
	"./img-btn-cta.png": 60227,
	"./img-modal-shell.png": 719372,
	"./img-reward-bar.png": 498981
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 912759;